import classNames from 'classnames';
import React from 'react';
import { NavbarPropTypes } from 'react-day-picker';

class Navbar extends React.Component {
  static propTypes = NavbarPropTypes;

  render() {
    const { className } = this.props;

    return (
      <div className={ classNames('calendar__navbar', className) }>
        <div className={ 'calendar-legend' }>
          <span className={ 'calendar-legend__color' }><span className={ 'calendar-legend__color--booked' } />Booked</span>
          <span className={ 'calendar-legend__color' }><span className={ 'calendar-legend__color--confirmed' } />Confirmed</span>
        </div>
        <span className='DayPicker-NavButton DayPicker-NavButton--prev calendar__navbar__button calendar__navbar__button--prev'
          onClick={ this._handlePreviousClick }>
          <i className='fa fa-chevron-left' />
        </span>
        <span className='DayPicker-NavButton DayPicker-NavButton--next calendar__navbar__button calendar__navbar__button--next'
          onClick={ this._handleNextClick }>
          <i className='fa fa-chevron-right' />
        </span>
      </div>
    );
  }

  // private

  _handleNextClick      = this._handleNextClick.bind(this);
  _handlePreviousClick  = this._handlePreviousClick.bind(this);

  _handleNextClick() {
    return this.props.onNextClick();
  }

  _handlePreviousClick() {
    return this.props.onPreviousClick();
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_Navbar.jsx